// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3Oxvl","itemTitle":"ClientEmergencyInfo_itemTitle__3zXvO","itemText":"ClientEmergencyInfo_itemText__2HNVE"};